import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import LoginForm from './components/LoginForm';
import Orders from './components/Orders';
import Specimens from './components/Specimens';
import Layout from './components/Layout';
import Users from './components/Users';
import AccessioningDashboard from './components/AccessioningDashboard';
import SpecimenClassAdmin from './components/SpecimenClassAdmin';
import Patients from './components/Patients';
import Automation from './components/Automation';
import Locations from './components/Locations';
import Dashboard from './components/Dashboard';
import Macros from './components/Macros';
import Roles from './components/Roles';
import MyAccount from './components/MyAccount';
import MyTasks from './components/MyTasks';
import CPTCodes from './components/CPTCodes';
import SNOMEDCodes from './components/SNOMEDCodes';
import ICDCodes from './components/ICDCodes';
import Modifiers from './components/Modifiers';
import SpecimenMapping from './components/SpecimenMapping';
import DiagnosisCodeMapping from './components/DiagnosisCodeMapping';
import PartnerIntegration from './components/PartnerIntegration';
import Reports from './components/Reports';
import Billing from './components/Billing';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';
import AccessibilityManager from './components/AccessibilityManager';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AccessibilityManager />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginForm />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/specimens" element={<Specimens />} />
              <Route path="/users" element={<Users />} />
              <Route path="/accessioning" element={<AccessioningDashboard />} />
              <Route path="/admin/specimen-classes" element={<SpecimenClassAdmin />} />
              <Route path="/patients" element={<Patients />} />
              <Route path="/automation" element={<Automation />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/macros" element={<Macros />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/roles" element={<Roles />} />
              <Route path="/my-account" element={<MyAccount />} />
              <Route path="/my-tasks" element={<MyTasks />} />
              <Route path="/codes/cpt" element={<CPTCodes />} />
              <Route path="/codes/snomed" element={<SNOMEDCodes />} />
              <Route path="/codes/icd10" element={<ICDCodes />} />
              <Route path="/codes/modifiers" element={<Modifiers />} />
              <Route path="/codes/specimen-mapping" element={<SpecimenMapping />} />
              <Route path="/codes/diagnosis-mapping" element={<DiagnosisCodeMapping />} />
              <Route path="/admin/partner-integration" element={<PartnerIntegration />} />
              <Route path="/billing" element={<Billing />} />
            </Route>
            {/* Catch-all route for invalid URLs */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
